import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { QueueSummaryResponse } from '@utils/types/back-office/priority-queue';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';

export const useGetQueueSummary = (organizationId?: number) => {
  const { t } = useTranslation();

  const fetchSummary = async () => {
    const base = GET_URL().priorityQueueSummary;
    const url =
      organizationId !== undefined
        ? `${base}?organization_id=${organizationId}`
        : base;
    const { data } = await Axios.get<QueueSummaryResponse>(url);
    return data;
  };

  return useQuery<QueueSummaryResponse, AxiosError<BaseError>>(
    ['queueSummary', organizationId],
    fetchSummary,
    {
      useErrorBoundary: false,
      refetchInterval: 5000,
      onError: (error: AxiosError<BaseError>) => {
        const d = error.response?.data as Record<string, unknown>;
        const msg =
          (d?.error_description as string) ||
          (d?.detail as string) ||
          (d?.error as string) ||
          (d?.message as string) ||
          t('an-error-occurred');
        toast.error(String(msg));
      }
    }
  );
};
